import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './context/AuthContext.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { Elements } from '@stripe/react-stripe-js'; // Import Elements
import { loadStripe } from '@stripe/stripe-js'; // Import loadStripe

// Load Stripe outside of a component's render to avoid
// recreating the Stripe object on every render.
// Use your Stripe publishable key from environment variables.
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

// Suppress ReactQuill findDOMNode deprecation warning
const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('findDOMNode')) {
    return; // Suppress findDOMNode warnings
  }
  originalWarn.apply(console, args);
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <Elements stripe={stripePromise}> {/* Wrap App with Elements */}
          <App />
        </Elements>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
